import { createReducer, on } from '@ngrx/store';
import { FlattenGraphQl } from 'src/app/utility';
import { ShopifyError } from '../../models';
import { Order } from '../../models/order.model';

import * as actions from '../actions/orders.action';
import * as utility from '../../../utility';
export interface OrdersState {
  entities: { [id: string]: Order };
  loading: boolean;
  loaded: boolean;
  errors: ShopifyError[];
  pageInfo?: {
    cursor: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export const initialState: OrdersState = {
  loading: false,
  loaded: false,
  errors: [],
  entities: {},
  pageInfo: {
    cursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

export const ordersReducer = createReducer(
  initialState,
  on(actions.LoadOrders, (state: OrdersState) => {
    return {
      ...state,
      loading: true,
      loaded: false,
      errors: [],
    };
  }),
  on(actions.LoadOrdersSuccess, (state: OrdersState, { orders }) => {
    const ordersResult = orders?.edges.map((e: { node: any }) => FlattenGraphQl(e.node));
    const entities = utility.ToEntities(ordersResult, 'id', state.entities);

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      pageInfo: {
        cursor: orders?.edges[orders?.edges.length - 1]?.cursor || state?.pageInfo?.cursor,
        hasNextPage: orders?.pageInfo.hasNextPage,
        hasPreviousPage: orders?.pageInfo.hasPreviousPage,
      },
      errors: [],
    };
  }),
  on(actions.LoadOrdersFail, (state: OrdersState, { errors }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      errors,
    };
  })
);

export const getOrdersLoading = (state: OrdersState) => state.loading;
export const getOrdersLoaded = (state: OrdersState) => state.loaded;
export const getOrdersErrors = (state: OrdersState) => state.errors;
export const getOrders = (state: OrdersState) => state.entities;
export const getOrdersPageInfo = (state: OrdersState) => state.pageInfo;
